"use client";

import { useMemo } from "react";
import { SessionProvider } from "next-auth/react";
import { HeroUIProvider } from "@heroui/react";
import { useRouter } from "next/navigation";
import { GrowthBookPayload } from "@growthbook/growthbook";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { TopbarTitleProvider } from "@/contexts/topbar";
import { createGrowthBookClientProvider } from "@/infrastructure/featureFlags/growthBookClientProvider";
import { FeatureFlagsAttributes } from "@/domain/featureFlags";
type ProvidersProps = {
  children: React.ReactNode;
  featureFlagsPayload: GrowthBookPayload;
  featureFlagsAttributes: FeatureFlagsAttributes;
};
const Providers = ({
  children,
  featureFlagsPayload,
  featureFlagsAttributes
}: ProvidersProps) => {
  const router = useRouter();
  const gb = useMemo(() => createGrowthBookClientProvider(featureFlagsPayload, featureFlagsAttributes), [featureFlagsPayload, featureFlagsAttributes]);
  return <GrowthBookProvider growthbook={gb} data-sentry-element="GrowthBookProvider" data-sentry-component="Providers" data-sentry-source-file="Providers.tsx">
      <HeroUIProvider navigate={router.push} data-sentry-element="HeroUIProvider" data-sentry-source-file="Providers.tsx">
        <SessionProvider data-sentry-element="SessionProvider" data-sentry-source-file="Providers.tsx">
          <TopbarTitleProvider data-sentry-element="TopbarTitleProvider" data-sentry-source-file="Providers.tsx">{children}</TopbarTitleProvider>
        </SessionProvider>
      </HeroUIProvider>
    </GrowthBookProvider>;
};
export { Providers };